import { Grid, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: "100%", width: "100%", position: "absolute" }}>
      <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%", height: "100%" }}>
        <Grid item container spacing={1} direction="column" alignItems="center">

          <Grid item>
            <ErrorIcon sx={{ width: "64px", height: "64px" }} color="info" />
          </Grid>

          <Grid item >
            <Typography variant="h6" textAlign="center">{t("notFound:title")}</Typography>
            <Typography variant="body1" textAlign="center" sx={{ width: "360px", maxWidth: "calc(100vw - 32px)", marginBottom: "16px" }} color="textSecondary">
              {t("notFound:description")}
            </Typography>
          </Grid>

        </Grid>
      </Grid>
    </Box>
  );
}
